import { EstateType } from "@/enums/EstateType";

export const usesInteractiveMasterplan = (
  estateType?: EstateType | string
): boolean =>
  estateType === EstateType.RESIDENTIAL_COMMUNITY ||
  estateType === EstateType.LAND_SUBDIVISION;

export const getEstateMapRouteName = (
  estateType?: EstateType | string
): "MasterplanViewV2" | "EstateMapV2" =>
  usesInteractiveMasterplan(estateType) ? "MasterplanViewV2" : "EstateMapV2";

export const getEstateMapPath = (
  estateId: string,
  estateType?: EstateType | string
): string =>
  usesInteractiveMasterplan(estateType)
    ? `/v2/estate/masterplan/${estateId}`
    : `/v2/estate/${estateId}`;
